import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { t } from "@lingui/macro";

const DateSelectionModal = ({ onDatesSelected, onClose }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    if (!startDate || !endDate) {
      setErrorMessage(t`Please select both dates.`);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);

    if (start < today || end < today) {
      setErrorMessage(t`Dates cannot be in the past.`);
      return;
    }

    if (start >= end) {
      setErrorMessage(t`Start date must be earlier than end date.`);
      return;
    }

    setErrorMessage("");
    onDatesSelected(startDate, endDate);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{t`Select Reservation Dates`}</h2>

        {errorMessage && (
          <div className="mesage-container error">
            {errorMessage}
          </div>
        )}

        <div className="date-picker-group">
          <div className="input-container">
            <label>
              <strong>{t`Start Date:`}</strong>
            </label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              minDate={new Date()}
              placeholderText={t`Select start date`}
            />
          </div>

          <div className="input-container">
            <label>
              <strong>{t`End Date:`}</strong>
            </label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate || new Date()}
              placeholderText={t`Select end date`}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button className="add-new-btn" onClick={handleSubmit}>
            {t`Next`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateSelectionModal;
